module.exports = __webpack_public_path__ + "static/img/6.110528d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/eng/6.png
// module id = sU/s
// module chunks = 0